import React, { Component } from 'react'
import { PageContainer } from '@toolpad/core/PageContainer'
import SmtpTable from '../../../components/admin_portal/smtp_config/SmtpTable'
import CreateSmtp from '../../../components/admin_portal/smtp_config/CreateSmtp'
import SmtpPageToolbar from '../../../components/admin_portal/smtp_config/SmtpPageToolbar'
import { get_company_list } from '../../../store/company/companySlice';
import { get_process_list } from '../../../store/process/processSlice';
import { connect } from 'react-redux';

class SmtpContainer extends Component {

  componentDidMount() {
    this.props.get_company_list({ page: 1, limit: 1000, qs: 'ac' });
    this.props.get_process_list({ page: 1, limit: 1000, qs: 'ac' });
  }

  handleConfigModal = (newVal, c_action) => {
    this.props.setConfigModalOpen(newVal);
    this.props.setAction(c_action)
  }

  handleConfigUpdateModal = async (newVal, c_action, config_id) => {
    let res = await this.props.get_email_config_details(config_id)
    if (res && !res.error) {
      this.props.setConfigModalOpen(newVal);
      this.props.setAction(c_action)
      this.props.setId(config_id)
    }
  };

  handleConfigSubmit = async (payload) => {
    let res = await this.props.create_email_config(payload);
    return res;
  };

  handleConfigUpdate = async (payload) => {
    let res = await this.props.update_email_config(payload);
    return res;
  };

  handleActivateDeactivateConfig = async (payload) => {
    let res = await this.props.activate_deactivate_email_config(payload);
    return res;
  };


  render() {
    const {
      is_email_config_modal_open,
      common_loading,
      total_email_config_count,
      page,
      c_action,
      config_id,
      selected_data,
      company_list,
      process_list
    } = this.props;
    return (
      <PageContainer maxWidth='xl' slots={{
        toolbar: SmtpPageToolbar,
      }} title={""} sx={{
        '& .css-lc31tn > .MuiTypography-h4': {
          fontSize: '14px',
          alignSelf: { md: 'center', xs: 'flex-start' },
        },
        '& .css-lc31tn': {
          bgcolor: theme => theme.palette.grey[200],
          px: 1.5,
          py: 0.1,
          borderRadius: '10px',
          my: 1.5,
          flexDirection: { md: 'row', xs: 'column' },
          alignItems: { md: 'unset', xs: 'flex-start' }
        },
        '& .css-1hwxlk6': {
          width: { md: 'unset', xs: '100%' },
          flexDirection: { md: 'row', xs: 'column' },
          marginLeft: { md: 'auto', xs: 'unset!important' }
        },
      }}>
        <SmtpTable
          total_email_config_count={total_email_config_count}
          is_loading={common_loading}
          page={page}
          is_email_config_modal_open={is_email_config_modal_open}
          handleConfigUpdateModal={this.handleConfigUpdateModal}
          activate_deactivate_email_config={this.handleActivateDeactivateConfig}
        />
        <CreateSmtp
          is_email_config_modal_open={is_email_config_modal_open}
          handleConfigModal={this.handleConfigModal}
          handleConfigSubmit={this.handleConfigSubmit}
          handleConfigUpdate={this.handleConfigUpdate}
          is_loading={common_loading}
          c_action={c_action}
          config_id={config_id}
          selected_data={selected_data}
          company_list={company_list}
          process_list={process_list}
        />

      </PageContainer>
    )
  }
}

const mapStateToProps = (state) => ({
  company_list: state.company.company_list,
  process_list: state.process.process_list,
})

const mapDispatchToProps = {
  get_company_list,
  get_process_list
}

export default connect(mapStateToProps, mapDispatchToProps)(SmtpContainer)
